//
//
//
//
//
//

export default {
  name: 'App',
  created () {
    this.golobleObject.getErrShow = this.getErrShow
  },
  methods: {
    getErrShow (obj) {
      console.log(obj)
      this.$toast(obj.msg ? obj.msg : '请求失败')
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue